import { render, staticRenderFns } from "./ContactFormAccount.vue?vue&type=template&id=5f14d0c2&scoped=true&"
import script from "./ContactFormAccount.vue?vue&type=script&lang=ts&"
export * from "./ContactFormAccount.vue?vue&type=script&lang=ts&"
import style0 from "./ContactFormAccount.vue?vue&type=style&index=0&id=5f14d0c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f14d0c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
